import styled from 'styled-components'

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  @media (max-width: 1279px) {
    flex-direction: row;
    gap: 9rem;
    margin-top: -1.5rem;
  }

  @media (max-width: 999px) {
    gap: 5.6rem;
    margin-top: 1rem;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 3rem;
  }
`
